import { ProjectTeamMemberDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Paths, ProjectPathParams } from '../../../app/router/app.router';
import { Snackbar } from '../../../ui/components/pure/snackbar/snackbar.component';
import { EditRoleModal } from './actions/edit-role-modal/edit-role.modal';
import { TeamMemberDetailsActions } from './actions/team-member-details.actions';
import { useTeamMemberDetails } from './hooks/team-member-details.hook';
import { ResendInviteModal } from './actions/resend-invite/resend-invite.modal';

export function TeamMemberDetailsActionsObserver({
  params,
  user,
  actions
}: {
  params: ProjectPathParams<Paths.teamMember>;
  user: ProjectTeamMemberDto;
  actions: ReturnType<typeof useTeamMemberDetails>[1];
}) {
  switch (actions.currentAction) {
    case TeamMemberDetailsActions.STATUS_CHANGE_ERROR:
      return (
        <Snackbar severity="error" onClose={() => actions.setAction(null)}>
          There was an error updating the team member
        </Snackbar>
      );
    case TeamMemberDetailsActions.STATUS_CHANGE_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          The team member's status has been changed
        </Snackbar>
      );
    case TeamMemberDetailsActions.EDIT_TEAM_MEMBER:
      return (
        <EditRoleModal
          open={true}
          projectID={params.projectID}
          userID={user.accountID}
          onClose={() => actions.setAction(null)}
        />
      );
    case TeamMemberDetailsActions.RESEND_INVITE:
      const invitationID = user.invitationID;
      if (invitationID) {
        return (
          <ResendInviteModal
            projectID={params.projectID}
            user={{ ...user, invitationID }}
            onClose={() => actions.setAction(null)}
            onSuccess={() => actions.setAction(TeamMemberDetailsActions.RESEND_INVITE_SUCCESS)}
          />
        );
      } else {
        return null;
      }

    case TeamMemberDetailsActions.RESEND_INVITE_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          The invitation has been resent
        </Snackbar>
      );
    default:
      return null;
  }
}
